import { render } from "./ChildEvent.vue?vue&type=template&id=54e45343"
import script from "./ChildEvent.vue?vue&type=script&lang=js"
export * from "./ChildEvent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__